<template>
  <technical-page-wrapper>
    <technical-section
      :title="t('work')"
      :description="t('serviceWillBeRestoredSoon')"
      image="/img/technical_works.webp"
    >
      <template #action>
        <ol-button
          class="technical-page__btn"
          :disabled="loading"
          :label="t('refresh')"
          variant="secondary"
          :size="mediaQueries.mobile ? 'sm' : 'md'"
          @click="updateStatusServer"
        >
          <template #leftIcon>
            <icon name="refresh" />
          </template>
        </ol-button>
      </template>
    </technical-section>
  </technical-page-wrapper>
</template>

<script setup>
import { inject, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { OlButton } from '@gamesite/game-core'
import TechnicalPageWrapper from 'components/technical/TechnicalPageWrapper.vue'
import TechnicalSection from 'components/technical/TechnicalSection.vue'
import { useQueryApp } from 'hooks/apolloQuery.js'
import { consoleLogAPI } from 'src/common/functions'
import { notification } from 'src/core/hooks/notifications'
import getUnderdev from 'src/apollo/queries/getUnderdev.gql'
const { t } = useI18n()
const mediaQueries = inject('mediaQueries')

const loading = ref(false)
function updateStatusServer() {
  loading.value = true

  const { onResult, onError } = useQueryApp(getUnderdev, {}, { fetchPolicy: 'network-only' })

  onResult(({ data }) => {
    if (data?.siteInfo?.underDev === false) {
      location.reload()
    }
    loading.value = false
  })

  onError((e) => {
    consoleLogAPI(e)
    notification({ type: 'warning', text: t('serverErrorTryAgain') })
    loading.value = false
  })
}
</script>

<style lang="scss">
.technical-page__btn {
  margin-top: 16px;
}
</style>
